module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_3-c07bd99209d59bf1cf10b4f928e0b3d3.png";